<template>
    <div id="expiration" class="control">
        <div class="select">
            <select id="months" v-model="chosenMonth">
                <option :value="null" disabled>Month</option>
                <option v-for="month in months" :disabled="!validMonth(month)" :key="month" :value="getPaddedMonth(month)">
                    {{getPaddedMonth(month)}}
                </option>
            </select>
        </div>
        
        <div class="select">
            <select id="years" v-model="chosenYear">
                <option :value="null" disabled>Year</option>
                <option :key="year" v-for="year in years" :value="year">
                    {{year}}
                </option>
            </select>
        </div>
    </div>
</template>


<script>
import * as moment from "moment";

export default {
    data() {
        return {
            chosenYear: null,
            chosenMonth: null,
            months: [],
            years: []
        }
    },
    mounted () {
        let currentYear = moment().year();
        let currentMonth = moment().month();
        
        // end of year, can't choose this year
        if (currentMonth !== 11) {
            this.years.push(currentYear);
        }
        
        for (let i = 1; i <= 12; i++) {
            this.months.push(i);
        }
        
        let year = currentYear;
        for (let i = 0; i < 10; i++) {
            year++;
            this.years.push(year);
        }
        // setDefaultMonthYear()
    },
    methods: {
        setDefaultMonthYear() {
            this.chosenYear = this.years[0];

            for (let month of this.months) {
                // get valid months for this year
                if (this.chosenYear === currentYear) {
                    if (this.validMonth(month)) {
                        this.chosenMonth = month;
                        break;
                    }
                } else {
                    this.chosenMonth = month;
                    break;
                }
            }
        },
        getPaddedMonth(month) {
            return `${month}`.padStart(2, '0');
        },
        validMonth(month) {
            // handle current year, disable current month and before
            if (this.chosenYear === moment().year()) {
                if (month <= moment().month()) {
                    return false;
                }
            }
            return true;
        },
        emitChanges() {
            let expiry = null;

            if (this.chosenYear && this.validMonth(this.chosenMonth)) {
                expiry = this.chosenMonth.toString().padStart(2, '0') + this.chosenYear.toString().substr(-2);
            }
            
            this.$emit('dateChosen', expiry);
        }
    },
    watch: {
        chosenYear (newYear, oldVal) {
            if (!this.validMonth(this.chosenMonth)) {
                this.chosenMonth = null;
            }
            this.emitChanges();
        },
        chosenMonth () {
            this.emitChanges();
        }
    }
    
}
</script>

<style lang="scss" scoped>
    #expiration {
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/checkout/payment/CreditCardExpiration.vue